import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useDeleteCameraGroup(
  cameraGroupId: string,
  onSuccess: () => void
) {
  const url = `/v2/orm/camera_groups/${cameraGroupId}`;

  const request = new Request(url, {
    method: 'DELETE',
  });

  return useAuthenticatedMutation(request, {
    onSuccessInvalidationKeys: [['camera-groups']],
    onSuccess,
  });
}

export default useDeleteCameraGroup;
